import * as React from 'react';
import MobileVerifyComponent from '../../components/MobileVerification/MobileVerifyComponent';
import AgreementComponent from '../../components/Agreement/AgreementComponent';
import SecurityVerificationComponent from '../../components/SecurityVerification/SecurityVerificationComponent';
import Accordion from "../../common/Accordion/Accordion";
import PersonalInfoComponent from '../PersonalInfo/PersonalInfoComponent';
import {Context} from '../../state/Store';
import '../SignupForm/SignUpFormContainer.css';
import * as _ from 'lodash';
import Notifier from '../../common/Notifier/Notifier';
import {useTranslation} from "react-i18next";

const UserInfoComponent = () => {
  const [state] = React.useContext(Context);
  const [touched, setTouched] = React.useState({});
  const [error, setError] = React.useState({address1: {val:''}, address2: {val:''}, address3: {val:''}, address4: {val:''}, city: {val:''}, state: {val:''}, postalcode: {val:''}, province: {val:''}, county: {val:''}});
  const [showPaymentDetails, setShowPaymentDetails] = React.useState(false);
  const [accordionState, setAccordionOpenState] = React.useState(0);
  const [createAccountStatus, setCreateAccountStatus] = React.useState({checked:false, createAccountApi: false});
  const [checkbox, setCheckbox] = React.useState(false);
  const {t} = useTranslation();

  const updateError = (name, isValid, val, errMsg) => {
    setError(error => {
      return {...error, ...{[name]: {isValid: isValid, val: val,msg: errMsg}}}
    });
  }

  const updateTouched = (name, status) => {
    setTouched(touched => {
      return{...touched, ...{[name]: status}}
    });
  }

  const updateCheckbox = (status) => {
    setCheckbox(status);
  }

  const displayPaymentDetails = (flag) => {
    return setShowPaymentDetails(flag);
  }

  const openAccordionSection = (accordionIndex) => {
    setAccordionOpenState (accordionIndex)
  }

  const updateCreateAccountStatus = (checkbox, button) => {
    setCreateAccountStatus({checked:checkbox, createAccountApi: button});
  }

  return (
    <>
    {state.nextStep && state.countryInfo !== undefined && state.operationId === '' &&
    <div className="contentContainer">
      <div className="upperContentContainer">
      {state.apiError && <Notifier type="error" message={t('signup.apiError')} position='apiError' />}
      {
        !_.isEmpty(state.selectedPromo) && !state.selectedPromo.creditCardRequired && !state.selectedPromo.validationCodeRequired ?
        <Accordion accordionState={accordionState} openAccordionSection={openAccordionSection}>
          <div label={t('personalInfo.addressInfo','Address information')}>
            <PersonalInfoComponent error={error} updateError={updateError} updateTouched={updateTouched} touched={touched} openAccordionSection={openAccordionSection} />
          </div>
          <div label={(!_.isEmpty(state.selectedPromo) && state.selectedPromo.programType === 'SE-TRIAL')? t('mobileVerify.customerPhoneLabel', 'Customer phone number') :t('mobileVerify.contactPhoneLabel','Contact phone number')}>
            <MobileVerifyComponent openAccordionSection={openAccordionSection} />
          </div>

          <></>
        </Accordion>
        :

        !_.isEmpty(state.selectedPromo) && !state.selectedPromo.creditCardRequired  ? 
        <Accordion accordionState={accordionState} openAccordionSection={openAccordionSection}>
        <div label={t('personalInfo.addressInfo','Address information')}>
          <PersonalInfoComponent error={error} updateError={updateError} updateTouched={updateTouched} touched={touched} openAccordionSection={openAccordionSection} />
        </div>
        <div label={t('mobileVerify.mobileVerificationLabel','Mobile verification')}>
          <MobileVerifyComponent openAccordionSection={openAccordionSection} />
        </div>
        </Accordion>
        :
        <Accordion accordionState={accordionState} openAccordionSection={openAccordionSection}>
        <div label={t('personalInfo.addressInfo','Address information')}>
          <PersonalInfoComponent error={error} updateError={updateError} updateTouched={updateTouched} touched={touched} openAccordionSection={openAccordionSection} />
        </div>
        <div label={t('mobileVerify.mobileVerificationLabel','Mobile verification')}>
          <MobileVerifyComponent openAccordionSection={openAccordionSection} />
        </div>
        <div label={t('securityVerification.paymentVerifyLabel','Payment verification')}>
          <SecurityVerificationComponent showPaymentDetails={showPaymentDetails} displayPaymentDetails={displayPaymentDetails} openAccordionSection={openAccordionSection} updateCreateAccountStatus={updateCreateAccountStatus} 
            updateCheckbox={updateCheckbox}
          />
        </div>
      </Accordion>
    }
        
      </div>
      <AgreementComponent createAccountStatus={createAccountStatus} updateCreateAccountStatus={updateCreateAccountStatus} updateCheckbox={updateCheckbox} checkbox={checkbox}/>
    </div>}
    </>
  )
}

export default UserInfoComponent;
